import React, { FC, useState, useEffect, Fragment } from "react";
import { StopDetail } from "components";
import "devextreme/data/odata/store";
import {
  useParamService,
  useDispatchService,
  useLogisticsService,
} from "services";
import { StopDetailsResponse } from "types";
import { faSpinner } from "@fortawesome/pro-solid-svg-icons"; //more icons at: https://fontawesome.com/icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const StopDetails: FC = () => {
  const { getIntValue, getStringValue } = useParamService();
  const { getStopDetails } = useDispatchService();
  const [stopDetailsData, setStopDetailsData] = useState<StopDetailsResponse>(
    {} as StopDetailsResponse
  );
  const [stop, setStop] = useState(null);
  const { getLoadByLoadNumber } = useLogisticsService();

  // Passed to the page from the Stops component.
  const [stopId] = useState<number>(getIntValue("stopId"));
  const [loadNumber] = useState<string>(getStringValue("loadNumber") as string);
  const [odsStopEventId] = useState<number>(getIntValue("odsStopEventId"));
  const [useOdsVersion] = useState<boolean>(() => {
    const useOdsFromQuery = `${getStringValue("useOdsVersion")}`.toLowerCase() === "true";
    return useOdsFromQuery || Boolean(odsStopEventId && odsStopEventId > 0);
  });

  useEffect(() => {
    getDataSource();
    if (!useOdsVersion && loadNumber) {
      getCompanyNotesbyLoadNumber();
    }
  }, []);

  const getDataSource = async () => {
    let results: StopDetailsResponse | null = null;

    if (useOdsVersion && odsStopEventId && odsStopEventId > 0) {
      results = await getStopDetails({useOdsVersion: true, odsStopEventId});
    } else if (stopId && stopId > 0) {
      results = await getStopDetails({loadNumber, stopId});
    }
    if (results) {
      setStopDetailsData(results);
    }
  };

  const getCompanyNotesbyLoadNumber = async () => {
    const respLoad = await getLoadByLoadNumber(loadNumber);

    if (respLoad.data && respLoad.data.stops && respLoad.data.stops.length > 0) {
      setStop((respLoad?.data?.stops).find((stop: any) => Number(stop?.id) === stopId));    
    }
  };

  return (
    <Fragment>
      {stopDetailsData.orders ? (
          <StopDetail
          stopDetails={stopDetailsData}
          loadNumber={loadNumber}
          stop={useOdsVersion ? stopDetailsData : stop}
        />
      ) : (
        <div className="center-icon center full-height red-component fas fa-spinner fa-spin">
          <FontAwesomeIcon icon={faSpinner} size={"3x"} />
        </div>
      )}
    </Fragment>
  );
};

export default StopDetails;
